import * as React from "react";
// import { ProductTile } from "@project-stories/ecommerce/Product/ProductTile";
import { ProductTileSearchResults } from "@project-stories/client/ProductTileSearch/ProductTileSearchResults";
import { BlogArticleTile } from "@arctheme-components/blog/BlogArticleTile/BlogArticleTile";
import useMobileBreakpoint from "@mindarc/arctheme-components/frontend/src/hooks/useMobileBreakpoint";

export const HeaderSearchResults = ({ settings, type, results }) => {

  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);

  return (
    <div className={`grid grid-cols-${isMobile ? 1 : 2} gap-x-4 gap-y-4`}>
      {type == "products" &&
        results &&
        results.map((product) => (
          <ProductTileSearchResults
              settings={settings}
            product={product}
            key={product.id}
            siblings={undefined}
          />
        ))}
      {type == "articles" &&
        results.map((article) => (
          <BlogArticleTile
            article={article}
            key={article.id ? article.id : article.objectID}
            settings={settings}
            show_excerpt={true}
          />
        ))}
    </div>
  );
};
